export function getHDSTabblableComponents(node) {
    const tabbableNodes = [];
    if (!node)
        return [];
    node.childNodes.forEach(childNode => {
        if (childNode.isTabbable) {
            tabbableNodes.push(childNode);
        }
        if (childNode.hasChildNodes()) {
            childNode.childNodes.forEach(grandchildNode => {
                tabbableNodes.push(...getHDSTabblableComponents(grandchildNode));
            });
        }
    });
    return tabbableNodes;
}
//# sourceMappingURL=hds-tabbable.js.map